import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { borderRadius } from "react-select/src/theme";

interface ConfirmModalProps {
  title?: string;
  message?: string;
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal = (props: ConfirmModalProps) => {
  const { title, message, isOpen, onConfirm, onCancel } = props;
  return (
    <Dialog open={isOpen} onClose={onCancel}>
      <DialogTitle>{title ?? "保存の確認"}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message ?? "変更を保存しますか?"}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          キャンセル
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          はい
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
